if (!customElements.get('product-add-card-container')) {
  customElements.define('product-add-card-container', class RecommendAddCards extends HTMLElement {
    constructor() {
      super();
      this.recommendProdEls = this.querySelectorAll('.product-add-card');
      this.modifyPriceOnProdAddCartCheck();
    }

    getRecommandedProducts() {
      var products = [];
      this.recommendProdEls?.forEach(function (el) {
        if (el && document.getElementById(el.getAttribute('for'))?.checked) {
          var quantity = parseInt(el.querySelector('[data-id="quantity"]')?.value, 10);
          quantity = isNaN(quantity) ? 0 : quantity;
          var id = el.querySelector('[data-id="id"]')?.value;
          if (quantity > 0 && id !== undefined) {
            products.push({
              form_type: "product",
              utf8: "✓",
              id,
              quantity
            });
          }
        }
      });

      return products;
    }

    modifyPriceOnProdAddCartCheck() {
      this.querySelectorAll('.pac-checkbox').forEach(function(el) {
        el.addEventListener('change', function () {
          _ThemeUtils._ProductPaymentPrices.modifyPaymentPrice();
        });
      });
    }
  });
}


